import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modal';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Button from '../Form/Button';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

// `invoice` is the row from the invoices table (has .id, .invoiceNumber, .patient) —
// shown as a controlled modal (invoice != null) rather than a boolean show flag, so
// the form's defaultValues (patient email) can key off the invoice being sent.
export default function SendInvoiceEmailModal({ invoice, onClose }) {
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (data) => {
        setIsLoading(true);
        axios.post(`${API_BASE_URL}/api/v1/invoice/${invoice.id}/send-email`, { email: data.email }, { withCredentials: true })
            .then(() => {
                toast.success('Facture envoyée par email.');
                onClose();
            })
            .catch(() => toast.error("Erreur lors de l'envoi de la facture."))
            .finally(() => setIsLoading(false));
    };

    return (
        <Modal
            id="sendInvoiceEmailModal"
            title="Envoyer la facture par email"
            show={!!invoice}
            onClose={onClose}
            icon={faEnvelope}
            iconBg="#eff6ff"
            iconColor="#2563eb"
            classSize="modal-sm"
            footer={
                <Button isLoading={isLoading} loadingMessage="Envoi..." type="submit" form="sendInvoiceEmailForm" className="modal-btn-primary">
                    <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                    Envoyer
                </Button>
            }
        >
            {invoice && (
                <Form
                    id="sendInvoiceEmailForm"
                    onSubmit={onSubmit}
                    defaultValues={{ email: invoice.patient?.email || '' }}
                    key={invoice.id}
                >
                    <div className="mb-2">
                        <label className="cdm-field-label">Adresse email <span className="text-danger">*</span></label>
                        <InputText
                            name="email"
                            type="email"
                            placeholder="exemple@email.com"
                            autofocus
                            validationRules={{
                                required: "L'email est requis",
                                pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Adresse email invalide' },
                            }}
                        />
                    </div>
                    <p style={{ fontSize: 12, color: '#9ca3af', margin: 0 }}>
                        La facture <strong>{invoice.invoiceNumber}</strong> sera envoyée en pièce jointe PDF.
                    </p>
                </Form>
            )}
        </Modal>
    );
}
